import { frontendURL } from 'dashboard/helper/URLHelper';

const LandingPagesIndex = () => import('./pages/LandingPagesIndex.vue');
const LandingPageEditor = () => import('./pages/LandingPageEditor.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/landing-pages'),
      name: 'landing_pages_index',
      component: LandingPagesIndex,
      meta: {
        permissions: ['administrator', 'agent'],
      },
    },
    {
      path: frontendURL('accounts/:accountId/landing-pages/new'),
      name: 'landing_page_new',
      component: LandingPageEditor,
      meta: {
        permissions: ['administrator', 'agent'],
      },
    },
    {
      path: frontendURL(
        'accounts/:accountId/landing-pages/:landingPageId/edit'
      ),
      name: 'landing_page_edit',
      component: LandingPageEditor,
      meta: {
        permissions: ['administrator', 'agent'],
      },
    },
  ],
};
